import { Fragment, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import Collapse from "@material-ui/core/Collapse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSolarPanel } from "@fortawesome/free-solid-svg-icons";

import { useHttpClient } from "../../shared/hooks/httpHook";
import { LoadingSpinnerOverlayRegular } from "../../shared/components/UIElements/LoadingSpinnerOverlayRegular";
import { addThousandSeparator } from "../../shared/util/addThousandSeparator";
import { ProposalData, AuthContextProps } from "../../shared/data/types";

import "./PropDashUcItem.scss";

interface PropDashPVModItemProps {
  auth: AuthContextProps;
  index: number;
  loadedPvMod: ProposalData["pvModuleData"][0];
}

export const PropDashPVModItem = (props: PropDashPVModItemProps) => {
  const { loadedPvMod, auth, index } = props;
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Fragment>
      <div
        className="cust-prop-item-prop"
        onClick={(e) => {
          setOpen(!open);
        }}
      >
        <div className="cust-prop-item-prop__data">
          <p className="cust-prop-item-prop__data-item cust-prop-item-prop__data-item--thin">
            {loadedPvMod?.manufacturer || ""}
          </p>
          <div className="cust-prop-item-prop__user-data">
            <FontAwesomeIcon
              icon={faSolarPanel}
              style={{ fontSize: "1.25rem", marginRight: "0.25rem" }}
            />
            <div className="cust-prop-item-prop__user-data-content">
              <p className="cust-prop-item-prop__data-item">
                {addThousandSeparator(loadedPvMod?.power)} Wp
              </p>
              <p className="cust-prop-item-prop__data-item">
                {loadedPvMod?.quantity} Unidades
              </p>
            </div>
          </div>
        </div>
        <div className="cust-prop-item-prop__controls">
          <IconButton
            size="small"
            title={open ? "Ver Mais" : "Fechar"}
            className={`table__item-action${open ? "--open" : ""}`}
            onClick={(e) => {
              setOpen(!open);
              e.stopPropagation();
            }}
          >
            <ExpandMoreRoundedIcon style={{ fontSize: "22px" }} />
          </IconButton>
        </div>
        <div className="cust-prop-item-prop__details">
          <Collapse in={open}>
            <div className="cust-prop-item-prop__details-content">
              <p className="cust-prop-item-prop__data-item cust-prop-item-prop__data-item--thin">
                Garantia (defeitos):{" "}
                <span className="cust-prop-item-prop__data-item--highlight">
                  {loadedPvMod?.warrantyDefect} Anos
                </span>
              </p>
              <p className="cust-prop-item-prop__data-item cust-prop-item-prop__data-item--thin">
                Garantia (eficiência):{" "}
                <span className="cust-prop-item-prop__data-item--highlight">
                  {loadedPvMod?.warrantyEfficiency} Anos
                </span>
              </p>
            </div>
          </Collapse>
        </div>
      </div>
    </Fragment>
  );
};
